import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-modal-sucesso',
  templateUrl: './modal-sucesso.component.html',
  styleUrls: ['./modal-sucesso.component.scss'],
})
export class ModalSucessoComponent implements OnInit {

  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();

  constructor() {}

  ngOnInit() {
  }

  fechar(bol) {
    this.fecharModal.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-sucesso/modal-sucesso.component.ts